export const useCropImage = async (
  imageSrc,
  pixelCrop,
  rotation = 0,
  flip = { horizontal: false, vertical: false },
): Promise<string> => {
  const newImage = new Image();
  await new Promise((resolve, reject) => {
    newImage.addEventListener('load', () => resolve(newImage));
    newImage.addEventListener('error', (error) => reject(error));
    newImage.setAttribute('crossOrigin', 'anonymous');
    newImage.src = imageSrc;
  });
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) return null;
  const rotRad = (rotation * Math.PI) / 180;
  const { width: bBoxWidth, height: bBoxHeight } = {
    width:
      Math.abs(Math.cos(rotRad) * newImage.width) + Math.abs(Math.sin(rotRad) * newImage.height),
    height:
      Math.abs(Math.sin(rotRad) * newImage.width) + Math.abs(Math.cos(rotRad) * newImage.height),
  };
  canvas.width = bBoxWidth;
  canvas.height = bBoxHeight;
  ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
  ctx.rotate(rotRad);
  ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
  ctx.translate(-newImage.width / 2, -newImage.height / 2);
  ctx.drawImage(newImage, 0, 0);
  const data = ctx.getImageData(pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height);
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  ctx.putImageData(data, 0, 0);
  return new Promise((resolve, reject) => {
    canvas.toBlob((file) => {
      resolve(URL.createObjectURL(file));
    }, 'image/jpeg');
  });
};
